export enum Claims {
  //Admin Users
  EditAdmins = 0,
  //Product
  GetProducts = 1,
  CreateProduct = 2,
  UpdateProduct = 3,
  DeleteProduct = 4,
  //Category
  EditCategories = 5,
  //Customer
  EditCustomers = 6,
  //CustomerCommissions
  EditCustomerCommissions = 7,
  //Order
  GetOrders = 8,
  UpdateOrder = 9,
  DeleteOrder = 10,
  //Brand
  EditBrands = 11,
  //Coupons
  EditCoupons = 12,
  EditGateway = 13, //Gateway
  //Base Item
  EditBaseItem = 14,
  //Scraping
  Scraping = 15,
  //Export Data
  ExportData = 16,
  //Notifications
  EditNotifications = 17,
  //AppMainScreenViewItem
  EditAppMainScreenViewItem = 18,
  //Discount
  EditDiscount = 19,
  //Prices
  EditPrices = 20,
  //Currency
  EditCurrencyRate = 21,
  //Collections
  EditCollections = 22,
  //Contries
  EditCountries = 23,
  //EmailPromotions
  EmailPromotions = 24,
  //CustomerCarts
  EditCustomerCarts = 25,
  //Memberships
  EditMemberships = 26,
  //Shipments
  EditShipments = 27,
  //Gifts
  EditGifts = 28,
  //Rating
  EditRating = 29,
  //FrontEndSettinfs
  EditSettings = 30,
  //Statistics
  Statistics = 31,
  //KargoCompanies
  EditKargoCompanies = 32,
  //EditAdminPermissions
  EditAdminPermissions = 33,
  //DeleteAdmin
  DeleteAdmin = 34,
  //UsersPage
  UsersPage = 35,
  //Blacklist
  EditBlacklist = 36,
  //Pricing Discounts
  PricingDiscounts = 37,
  //Cleaning Database
  CleaningDatabase = 38,
  //EditCustomerCarts
  EditCustomerCarts_CreateOrder = 39,
  EditCustomerCarts_DeleteItem = 40,
  EditCustomerCarts_ShowPrices = 41,
  EditCustomerCarts_ClickLinks = 42,
  EditCustomerCarts_ShowItems = 43,
  //UpdateOrder
  UpdateOrder_AcceptItem = 44,
  UpdateOrder_RejectItem = 45,
  UpdateOrder_EditItem = 46,
  UpdateOrder_ShipItem = 47,
  UpdateOrder_ShowPrices = 48,
  UpdateOrder_ShowItems = 49,
  UpdateOrder_ClickLinks = 50,
  UpdateOrder_GenerateLink = 51,
  UpdateOrder_ArchiveOrders = 52,
  UpdateOrder_TogglePayment = 53,
  UpdateOrder_GetLogs = 54,
  UpdateOrder_EditRecipientInfo = 55,
  UpdateOrder_EditDeliveryPrice = 56,
  UpdateOrder_SpecialDiscount = 57,
  UpdateOrder_ShowInvoice = 58,
  UpdateOrder_CaptureInvoice = 59,
}
